import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../utils/axios'
import { formatDateTime } from '../../utils/DateUtil';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCounts } from '../../context/CountsContext';

const BookingDetail = () => {
  const { id } = useParams();
  const [booking, setBooking] = useState(null);
  //const [bookings, setBookings] = useState([]);
  const [error, setError] = useState('');
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showReason, setShowReason] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const { refreshCounts } = useCounts();


  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await api.get(`/api/car-bookings/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setBooking(res.data);
      } catch (err) {
        console.error('Failed to load booking:', err);
        setError('Failed to load booking.');
      }
    };
    
    fetchBooking();
  }, [id]);
  //console.log(user);
  
  const handleReject = async () => {
    if (!rejectionReason.trim()) {
      alert('Please enter a rejection reason.');
      return;
    }

    try {
      await api.patch(`/api/car-bookings/${booking._id}/reject`, { reason: rejectionReason });
      alert('Booking rejected.');
      refreshCounts();
      navigate('/bookings');
    } catch (err) {
      console.error('Reject failed:', err);
      alert('Failed to reject booking.');
    }
  };

  const handleDelete = async (bookingId) => {
    if (!window.confirm('Are you sure you want to delete this booking?')) return;

    try {
      const token = localStorage.getItem('token');
      await api.delete(`/api/car-bookings/${bookingId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert('Booking deleted.');
      navigate('/bookings');
    //  setBookings(bookings.filter(b => b._id !== bookingId));
    } catch (err) {
      console.error('Delete failed:', err);
      alert('Failed to delete booking.');
    }
  };

  if (error) return <div className="container mt-4 alert alert-danger">{error}</div>;
  if (!booking) return <div className="container mt-4">Loading...</div>;

  return (
    <div className="container mt-4">
      <h2>Booking Detail</h2>
      {user?.isCarBookingAdmin && booking.status === 'PENDING_ADMIN' && (
        <button
          className="btn btn-success me-2 mb-3"
          onClick={async () => {
            const confirm = window.confirm('Are you sure you want to grant this booking?');
            if (!confirm) return;

            try {
              await api.patch(`/api/car-bookings/${booking._id}/grant`);
              alert('Booking granted');
              await refreshCounts();
              navigate('/bookings');
            } catch (err) {
              console.error(err);
              alert('Grant failed');
            }
          }}
        >
          GRANT BOOKING
        </button>
      )}
      
      {booking.userPassengers.some(p => p.user._id === user._id && !p.confirmed) && (
        <button
          className="btn btn-success text-white me-2 mb-3"
          onClick={async () => {
            const confirm = window.confirm('Confirm your participation in this booking?');
            if (!confirm) return;
            try {
              await api.put(`/api/car-bookings/${booking._id}/confirm`);
              alert('You have confirmed the booking.');
              await refreshCounts();
              navigate('/bookings');
            } catch (err) {
              console.error(err);
              alert('Confirmation failed');
            }
          }}
        >
          CONFIRM AS PASSENGER
        </button>
      )}

      {user?._id === booking.approver._id && booking.status === 'PENDING_APPROVER' && (
        <button
          className="btn btn-primary me-2 mb-3"
          onClick={async () => {
            const confirm = window.confirm('Are you sure you want to approve this booking?');
              if (!confirm) return;
            try {
              await api.patch(`/api/car-bookings/${booking._id}/approve`);
              alert('Booking approved');
              refreshCounts();
              navigate('/bookings');
            } catch (err) {
              console.error(err);
              alert('Approval failed');
            }
          }}
        >
          APPROVE
        </button>
      )}
      {(booking.status === 'PENDING_APPROVER' || booking.status === 'PENDING_ADMIN') &&
        (user._id === booking.approver._id || user?.isCarBookingAdmin) && (
          <>
            {!showReason ? (
              <button className="btn btn-danger me-2 mb-3" onClick={() => setShowReason(true)}>
                REJECT
              </button>
            ) : (
              <div className="mt-3">
                <textarea
                  className="form-control mb-2"
                  placeholder="Reason for rejection"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                />
                <button className="btn btn-danger me-2" onClick={handleReject}>
                  Submit Rejection
                </button>
                <button className="btn btn-secondary" onClick={() => setShowReason(false)}>
                  Cancel
                </button>
              </div>
            )}
          </>
      )}

      {booking.status === 'REJECTED' && (
        <div className="alert alert-danger mt-3">
          <strong>Rejected By:</strong> {booking.rejectedBy?.name || 'N/A'}<br />
          <strong>Reason:</strong> {booking.rejectionReason || 'No reason provided'}
        </div>
      )}

      <table className="table table-striped table-bordered text-start">
        <tbody>
          <tr>
            <th>Start</th>
            <td>{formatDateTime(booking.startDate)}</td>
          </tr>
          <tr>
            <th>End</th>
            <td>{formatDateTime(booking.endDate)}</td>
          </tr>
          <tr>
            <th>Purpose</th>
            <td>{booking.purpose}</td>
          </tr>
          <tr>
            <th>Destination</th>
            <td>{booking.destination}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>
              <span className={
                booking.status === 'REJECTED' ? 'badge bg-danger' :
                booking.status === 'GRANTED' ? 'badge bg-success' :            // ✅ New condition
                booking.status === 'CONFIRMED' ? 'badge bg-success' :
                booking.status === 'PENDING_APPROVER' ? 'badge bg-primary' :
                booking.status === 'PENDING_PASSENGERS' ? 'badge bg-warning' :
                'badge bg-info'
              }>
                {booking.status}
              </span>
              {booking.status === 'GRANTED' && (
                <div className="">
                (by: {booking.grantedBy?.name})
                </div>
              )}
            </td>

          </tr>
          <tr>
            <th>Requester</th>
            <td>{booking.requester?.name}</td>
          </tr>
          <tr>
            <th>Approver</th>
            <td>
              {['PENDING_PASSENGERS', 'PENDING_APPROVER'].includes(booking.status) ? '❌' : '✅'} 
              {booking.approver?.name || '—'}
            </td>
          </tr>
          <tr>
            <th>Assigned Vehicle</th>
            <td>
              {booking.preferredVehicle
                ? `${booking.preferredVehicle.name} (${booking.preferredVehicle.plateNumber})`
                : '—'}
            </td>
          </tr>
          <tr>
            <th>Staff Passengers</th>
            <td>
              {booking.userPassengers.length === 0 ? '—' : (
                <ul className="list-unstyled mb-0">
                  {booking.userPassengers.map((p, idx) => (
                    <li key={idx}>
                      {p.confirmed ? '✅' : '❌'} {p.user?.name || 'Unknown'} {p.confirmed ? '(Confirmed)' : '(Unconfirmed)'}
                    </li>
                  ))}
                </ul>
              )}
            </td>
          </tr>
          <tr>
            <th>Other Passengers</th>
            <td>{booking.nonUserPassengers?.length > 0 ? booking.nonUserPassengers.join(', ') : '—'}</td>
          </tr>
        </tbody>
      </table>
      
      {user?.role !== 'Executive' && (
        <div className="mt-3">
          <Link to={`/bookings`} className="btn btn-sm btn-info me-2">
              Back
            </Link>
          {(user?.isCarBookingAdmin || booking.requester._id === user?._id) &&
            !['GRANTED', 'REJECTED'].includes(booking.status) && (
            <>              
              <Link
                to={`/bookings/${booking._id}/edit`}
                className="btn btn-sm btn-warning me-2"
              >
                Edit
              </Link>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => handleDelete(booking._id)}
              >
                Delete
              </button>
            </>
          )}
        </div>
      )}

       
    </div>
  );
};

export default BookingDetail;
